var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSimacMix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.7,
    height: 29.921,
    viewBox: "0 0 112.7 29.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    transform: "translate(-4395.872 -3539.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_74",
    "data-name": "Trazado 74",
    d: "M10.652-4.395a2.06,2.06,0,0,0-.791-1.734,9.517,9.517,0,0,0-2.854-1.23A13.779,13.779,0,0,1,3.727-8.742a4.379,4.379,0,0,1-2.332-3.82,4.158,4.158,0,0,1,1.682-3.4A6.806,6.806,0,0,1,7.441-17.3a7.373,7.373,0,0,1,3.176.656,5.213,5.213,0,0,1,2.191,1.869,4.794,4.794,0,0,1,.8,2.689H10.652a2.674,2.674,0,0,0-.838-2.092,3.458,3.458,0,0,0-2.4-.756,3.612,3.612,0,0,0-2.256.621,2.068,2.068,0,0,0-.8,1.734,1.871,1.871,0,0,0,.867,1.564A9.99,9.99,0,0,0,8.086-9.791a13.153,13.153,0,0,1,3.2,1.348,5.089,5.089,0,0,1,1.77,1.734,4.517,4.517,0,0,1,.563,2.291,4.061,4.061,0,0,1-1.635,3.393A7.091,7.091,0,0,1,7.547.234a8.335,8.335,0,0,1-3.4-.686A5.719,5.719,0,0,1,1.729-2.344,4.716,4.716,0,0,1,.867-5.156H3.832a2.76,2.76,0,0,0,.961,2.25,4.208,4.208,0,0,0,2.754.8,3.656,3.656,0,0,0,2.326-.627A2.023,2.023,0,0,0,10.652-4.395ZM20.524,0H17.571V-17.062h2.953Zm8.664-17.062L34.11-3.984l4.91-13.078h3.832V0H39.9V-5.625l.293-7.523L35.153,0H33.032L28-13.137,28.3-5.625V0H25.344V-17.062ZM57.083-3.973H50.473L49.09,0H46.008l6.445-17.062h2.66L61.571,0H58.477ZM51.305-6.363h4.945l-2.473-7.078ZM77.7-5.555a6.161,6.161,0,0,1-2.016,4.26A6.872,6.872,0,0,1,71.009.234a6.654,6.654,0,0,1-3.592-.967,6.346,6.346,0,0,1-2.4-2.748,9.917,9.917,0,0,1-.879-4.137V-9.211A9.989,9.989,0,0,1,65-13.465,6.447,6.447,0,0,1,67.452-16.3a6.848,6.848,0,0,1,3.7-1A6.6,6.6,0,0,1,75.7-15.768a6.39,6.39,0,0,1,2,4.33H74.747a4.215,4.215,0,0,0-1.072-2.654,3.544,3.544,0,0,0-2.525-.814,3.462,3.462,0,0,0-2.971,1.413,7.064,7.064,0,0,0-1.061,4.146v1.513a7.494,7.494,0,0,0,.99,4.223,3.286,3.286,0,0,0,2.9,1.454,3.833,3.833,0,0,0,2.625-.785,4.094,4.094,0,0,0,1.113-2.613Z",
    transform: "translate(4430.872 3562.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M171.732,86.389a3.861,3.861,0,0,0-7.721.111,3.837,3.837,0,0,0,.456,1.82h0l0,.006a3.828,3.828,0,0,0,.293.458l3.109,4.842,3.108-4.842a3.833,3.833,0,0,0,.294-.458l0-.006h0a3.848,3.848,0,0,0,.455-1.931m-3.694,1.343a1.242,1.242,0,1,1,1.241-1.241,1.241,1.241,0,0,1-1.241,1.241",
    transform: "translate(4243 3466)",
    fill: "#e0007e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M173.607,97.048h-11.47a3.183,3.183,0,0,1-3.18-3.18V82.4a3.183,3.183,0,0,1,3.18-3.18h11.47a3.183,3.183,0,0,1,3.18,3.18v11.47a3.183,3.183,0,0,1-3.18,3.18m-11.47-15.973a1.325,1.325,0,0,0-1.323,1.323v11.47a1.325,1.325,0,0,0,1.323,1.323h11.47a1.325,1.325,0,0,0,1.323-1.323V82.4a1.325,1.325,0,0,0-1.323-1.323Z",
    transform: "translate(4243 3466)",
    fill: "#009ca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M182.872,97.048H180.9a1.518,1.518,0,0,1-1.516-1.516v-14.8a1.518,1.518,0,0,1,1.516-1.517h1.974v1.857h-1.633V95.191h1.633Z",
    transform: "translate(4243 3466)",
    fill: "#009ca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M154.845,97.048h-1.973V95.191h1.633V81.075h-1.633V79.218h1.973a1.519,1.519,0,0,1,1.517,1.517v14.8a1.518,1.518,0,0,1-1.517,1.516",
    transform: "translate(4243 3466)",
    fill: "#009ca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M176.787,101.11v1.973H174.93V101.45H160.814v1.633h-1.857V101.11a1.519,1.519,0,0,1,1.517-1.517h14.8a1.518,1.518,0,0,1,1.516,1.517",
    transform: "translate(4243 3466)",
    fill: "#009ca2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M158.957,75.135V73.162h1.857v1.633H174.93V73.162h1.857v1.973a1.519,1.519,0,0,1-1.517,1.517h-14.8a1.518,1.518,0,0,1-1.516-1.517",
    transform: "translate(4243 3466)",
    fill: "#009ca2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimacMix);
export default __webpack_public_path__ + "static/media/Logo_SIMAC_Mix_.24d49ffa7e63b48cd32319e6971ac4ed.svg";
export { ForwardRef as ReactComponent };